module.exports = __webpack_public_path__ + "img/intercom.dac5f4b9.jpg";